<template>
    <div>
        <v-flex xs12 sm12 d-block class="card-dados">
            <h3 class="card-dados__titulo">Lances</h3>

            <p class="ml-3 mb-2 legenda">
                Legenda:
                <v-icon size="15" color="green" class="ml-2 mr-1">fas fa-thumbs-up</v-icon>
                Vencendo
                <v-icon size="15" color="red" class="ml-2 mr-1">fas fa-thumbs-down</v-icon>
                Perdendo
            </p>

            <v-data-table :headers="colunas"
                          :items="lancesDaCompraDireta"
                          hide-actions
                          class="az-table-list tabela-lances">
                <template slot="items" slot-scope="props">
                    <tr>
                        <td>
                            {{ props.item.identificacaoSequencial }}
                        </td>
                        <td>
                            <ver-mais :tamanho="tamanho" :descricao="props.item.itens[0].descricao"
                                      :itens="props.item.itens"/>
                        </td>
                        <td align="right">
                            {{ props.item.melhorLance | cdCurrency(prefixo, quantidadeCasasDecimais) }} {{ sufixo }}
                        </td>
                        <td align="right">
                            <v-tooltip top>
                                <template slot="activator">
                                    <div class="texto-valor">
                                        <v-icon v-if="props.item.ganhando === 'GANHANDO'" size="15" color="green" class="mr-2">
                                            fas fa-thumbs-up
                                        </v-icon>
                                        <v-icon v-if="props.item.ganhando === 'PERDENDO'" size="15" color="red" class="mr-2">
                                            fas fa-thumbs-down
                                        </v-icon>
                                        <span v-if="props.item.ganhando === 'EMPATADO'" class="icone-empatado mr-2">E</span>
                                        {{ props.item.valor | cdCurrency(prefixo, quantidadeCasasDecimais)}} {{ sufixo }}
                                    </div>
                                </template>
                                <span v-if="props.item.ganhando === 'GANHANDO'">Você está vencendo!</span>
                                <span v-if="props.item.ganhando === 'PERDENDO'">Você está perdendo!</span>
                                <span v-if="props.item.ganhando === 'EMPATADO'">Você está empatado!</span>
                            </v-tooltip>

                            <v-tooltip id="botaoCancelar" v-if="props.item.podeCancelar && props.item.situacaoParaDarLance === 'EM_ANDAMENTO'" top>
                                <template slot="activator">
                                    <v-icon size="13" @click="exibirModalCancelarLance(props.item)" class="ml-2 mr-1">
                                        fas fa-times-circle
                                    </v-icon>
                                </template>
                                Cancelar Lance
                            </v-tooltip>
                        </td>
                        <td>
                            <div class="pl-2 d-flex justify-space-between">
                                <az-money v-if="valoresLances[props.index] && props.item.situacaoParaDarLance === 'EM_ANDAMENTO'"
                                          v-model="valoresLances[props.index].valorInserido"
                                          :disabled="compraDireta && compraDireta.situacao === 'SUSPENSA'"
                                          :maxLength="18"
                                          :precision="quantidadeCasasDecimais"
                                          :placeholder="placeholderValor"
                                          :prefix="prefixo"
                                          :suffix="sufixo"
                                          @blur="atualizarValorInserido($event, props.item, props.index)"
                                          @keyupEnter="efetuarLance($event, props.item, props.index)"
                                          class="pt-0 alinhar-direita"/>

                                <az-call-to-action id="botaoEnviarMelhorValor"
                                                   css-class="botao-enviar-melhor-valor text-uppercase desabilitado"
                                                   :disabled="compraDireta && compraDireta.situacao === 'SUSPENSA'"
                                                   @click="efetuarLance(valoresLances[props.index].valorInserido, props.item, props.index)"
                                                   v-if="props.item.situacaoParaDarLance === 'EM_ANDAMENTO'">
                                    Enviar
                                </az-call-to-action>

                                <v-tooltip v-if="props.item.situacaoParaDarLance !== 'EM_ANDAMENTO' && props.item.motivo" top class="botao-motivo text-md-center">
                                    <a slot="activator">
                                        {{ props.item.tipo === 'ITEM' ? 'Item' : 'Grupo de Itens' }}
                                        {{ props.item.situacaoParaDarLance | azEnum(situacoesItensELotes) }}
                                        <i class="fas fa-comment" aria-hidden="true"/>
                                    </a>
                                    {{ props.item.motivo }}
                                </v-tooltip>
                            </div>
                        </td>
                    </tr>
                </template>
            </v-data-table>
        </v-flex>

        <div class="az-actions-form acao-botao">
            <botao-voltar @voltar="irParaProposta"/>
        </div>

        <lance-modal-cancelar :exibirModal="mostrarDialogoCancelar"
                              :item="item"
                              :casasDecimais="quantidadeCasasDecimais"
                              :prefix="prefixo"
                              :suffix="sufixo"
                              @fechar="fecharModalCancelarLance"
                              @cancelarLance="tratarEventoCancelarLance"/>

        <modal-compra-suspensa :exibirModal="mostrarModalSuspensao"
                              @fechar="fecharModalSuspensao"/>
    </div>
</template>

<script>
import SmartTimerMixin from '@/core/mixins/SmartTimerMixin'
import {mapState} from 'vuex'
import {actionTypes, situacoesItensELotes} from '@/core/constants'
import LanceModalCancelar from '@/views/pages/fornecedor/etapas-participacao/lance/LanceModalCancelar'
import ModalCompraSuspensa from '@/views/pages/fornecedor/resultado/lance-desempate/ModalCompraSuspensa'

export default {
    name: 'Lance',
    mixins: [SmartTimerMixin],
    components: {
        LanceModalCancelar,
        ModalCompraSuspensa
    },
    data() {
        return {
            ganhando: '',
            compraDiretaId: null,
            propostaId: null,
            melhorValor: null,
            tamanho: null,
            lances: [],
            colunas: [
                {
                    value: 'sequencia',
                    sortable: true,
                    width: '5%',
                    text: 'Seq',
                    class: 'primary--text',
                    align: 'left'
                },
                {
                    value: 'descricao',
                    sortable: false,
                    width: '32%',
                    text: 'Descrição',
                    class: 'primary--text',
                    align: 'left'
                },
                {
                    value: 'melhorLance',
                    sortable: false,
                    width: '13%',
                    class: 'primary--text',
                    text: 'Melhor Lance',
                    align: 'right',
                },
                {
                    value: 'valor',
                    width: '15%',
                    text: 'Meu Último Lance',
                    sortable: false,
                    class: 'primary--text',
                    align: 'right'
                },
                {
                    align: 'center',
                    sortable: false,
                    text: 'Efetuar Lances',
                    value: 'valorInserido',
                    width: '25%',
                    class: 'primary--text'
                }
            ],
            mostrarDialogoCancelar: false,
            mostrarModalSuspensao: false,
            item: {},
            valoresLances: {},
            situacoesItensELotes
        }
    },
    computed: {
        ...mapState(['loki', 'resumoProposta', 'lancesDaCompraDireta', 'parametros', 'fornecedor', 'compraDireta']),
        quantidadeCasasDecimais() {
            if (this.resumoProposta.tipo === 'COM_DISPUTA' && this.resumoProposta.disputaPor === 'UNITARIO') {
                return this.fornecedor.quantidadeCasasDecimaisCompraDireta
            }
            return 2
        },
        prefixo() {
            if (this.resumoProposta.prefixoValor === '%') {
                return ''
            }
            return 'R$'
        },
        sufixo() {
            if(this.resumoProposta.prefixoValor === '%') {
                return this.resumoProposta.prefixoValor
            }
            return ''
        },
        placeholderValor() {
            if (this.resumoProposta.placeholderInputLances) {
                return this.resumoProposta.placeholderInputLances
            }
            return 'Valor'
        }
    },
    created() {
        window.addEventListener('resize', this.pegarTamanho)
        this.pegarTamanho()
    },
    async mounted() {
        try {
            this.setCompraDiretaIdEPropostaId()
            await this.buscarResumoProposta()
            await this.buscarLances()
            this.habilitarLoadingGlobal()
            this.atualizarListaDeLances()
            
            let timerInterval = 15000
            if (this.parametros.propriedadesCompraDiretas.frontendTimer.lancesFornecedor) {
                timerInterval = this.parametros.propriedadesCompraDiretas.frontendTimer.lancesFornecedor
            }
            
            this.createSmartTimer('buscarLances', 'buscarLances', timerInterval, {
                autostart: true,
                immediate: true
            })
        } catch (e) {
            this.mostrarNotificacaoErro(e.message)
        }
    },
    methods: {
        async buscarResumoProposta() {
            const infoObj = {
                compraDiretaId: this.compraDiretaId,
                propostaId: this.propostaId
            }
            await this.$store.dispatch(actionTypes.FORNECEDOR.BUSCAR_RESUMO_DA_COMPRA_DIRETA_NA_PROPOSTA, infoObj)
        },
        async buscarLances() {
            try {
                const dadosObj = {
                    compraDiretaId: this.compraDiretaId,
                    propostaId: this.propostaId
                }
                await this.$store.dispatch(actionTypes.FORNECEDOR.BUSCAR_LANCES_DA_COMPRA_DIRETA, dadosObj)
                await this.$store.dispatch(actionTypes.FORNECEDOR.BUSCAR_DETALHES_DA_COMPRA_DIRETA, this.compraDiretaId)
                if (this.compraDireta && this.compraDireta.situacao === 'SUSPENSA') {
                    this.stopSmartTimer('buscarLances')
                    this.mostrarModalSuspensao = true
                }
            } catch (error) {
                this.mostrarNotificacaoErro('Erro ao buscar lances: ' + error.message)
            }
        },
        async efetuarLance(novoValor, item, index) {
            if (novoValor === null) {
                throw new Error('Não é possível enviar um valor vazio.')
            }
            if (novoValor >= 10000000000) {
                throw new Error('Não é possível enviar um valor acima de 10 bilhões de reais.')
            }
            const objetoComboParametros = {
                compraDiretaId: this.compraDiretaId,
                propostaId: this.propostaId,
                dados: {
                    lanceId: item.id,
                    itemCompraDiretaId: item.itemCompraDiretaId,
                    loteCompraDiretaId: item.loteCompraDiretaId,
                    tipo: item.tipo,
                    valor: novoValor,
                    itemPropostaId: item.itemPropostaId,
                    lotePropostaId: item.lotePropostaId,
                    podeCancelar: true
                }
            }
            this.limparValoresLances(null, index)
            this.habilitarLoadingGlobal()
            this.setMensagemLoading('Efetuando Lance...')
            await this.$store.dispatch(actionTypes.FORNECEDOR.EFETUAR_LANCE, objetoComboParametros)
            const valor = this.$options.filters.cdCurrency(novoValor, this.prefixo,this.quantidadeCasasDecimais)+this.sufixo
            this.mostrarNotificacaoSucesso(`Lance de ${valor} efetuado com sucesso!`)
            this.desabilitarLoadingGlobal()
            this.limparValoresLances(null, index)
        },
        atualizarValorInserido(novoValor, item, index) {
            item.valorInserido = novoValor
            this.limparValoresLances(novoValor, index)
            this.$store.dispatch(actionTypes.FORNECEDOR.ATUALIZAR_VALOR_INSERIDO_PARA_LANCE, item)
        },
        async tratarEventoCancelarLance() {
            const itemObj = {
                compraDiretaId: this.compraDiretaId,
                propostaId: this.propostaId,
                item: this.item
            }
            this.fecharModalCancelarLance()
            await this.$store.dispatch(actionTypes.FORNECEDOR.CANCELAR_LANCE, itemObj)
            this.mostrarNotificacaoSucesso('Lance cancelado com sucesso.')
            await this.buscarLances()
        },
        atualizarListaDeLances() {
            let listaLances  = {}
            this.lancesDaCompraDireta.forEach((lance, index) => {
                listaLances[index] = {
                    valorInserido: null
                }
            })
            this.valoresLances = listaLances
        },
        exibirModalCancelarLance(item) {
            this.item = item
            this.mostrarDialogoCancelar = true
        },
        fecharModalCancelarLance() {
            this.mostrarDialogoCancelar = false
            this.item = {}
        },
        fecharModalSuspensao() {
            this.mostrarModalSuspensao = false
        },
        setCompraDiretaIdEPropostaId() {
            this.compraDiretaId = this.$route.params.id
            this.propostaId = this.$route.params.propostaId
        },
        pegarTamanho() {
            this.tamanho = .09 * window.innerWidth
        },
        irParaProposta() {
            this.$router.push({
                name: 'PropostaDoFornecedor',
                params: {
                    id: this.compraDiretaId,
                    propostaId: this.propostaId
                }
            })
        },
        limparValoresLances(valor, index) {
            this.valoresLances[index] = {
                valorInserido: valor
            }
        }
    },
    destroyed() {
        window.removeEventListener('resize', this.pegarTamanho)
    }
}
</script>

<style scoped lang="stylus">
    .legenda
        font-size 13px
        color #777

    .botao-enviar-melhor-valor.v-btn--outline
        background-color var(--v-primary-base) !important
        color #fff !important
        padding 0
        border 1px solid var(--v-primary-base) !important
        border-radius 2px
        max-height 34px
        margin-left 10px
        margin-right 0
        min-width 70px
        max-width 70px
        font-size 12px

    .botao-enviar-melhor-valor[disabled]
        opacity .5

    .tabela-lances
        border 0 solid #bebebe
        margin 0 16px 16px

        td, thead tr th
            border-right 0 solid #e7e7e7

        tr
            border-bottom 1px solid #e7e7e7 !important

        td:last-child, thead tr th:last-child
            border-right 0

        tr:last-child
            border-bottom 0 !important

        thead tr
            height 30px !important

        .texto-valor
            text-align right
            display inline-block

    .icone-empatado
        background-color rgba(0, 0, 0, .54)
        color #fff
        font-size 10px
        padding 1px 5px
        border-radius 50%
        font-weight bold
        cursor default

    @media (max-width 720px)
        .tabela-lances
            margin 0

            td:nth-of-type(1):before
                content "Sequência:"

            td:nth-of-type(2):before
                content "Descrição:"

            td:nth-of-type(3):before
                content "Melhor Lance:"

            td:nth-of-type(4):before
                content "Meu Último Lance:"

            td:nth-of-type(5):before
                content "Efetuar Lances:"

            td:nth-of-type(3)
                text-align left

            td:nth-of-type(4)
                text-align left

            td, tr th, tr
                border 0
</style>
